// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 头部样式调整 */
.logo-head {
  z-index: 999;
  position: relative;
  justify-content: space-between;
  background: #333333;
  min-height: 50px;
  display: flex;
  align-items: center;
}
.logo-head .more-info {
  margin: 0px 5px;
  padding: 0;
  color: rgba(255, 255, 255, 0.8) !important;
  font-size: 14px;
  list-style: none;
  display: flex;
  align-items: center;
}
.logo-head .more-info li a {
  color: rgba(255, 255, 255, 0.8) !important;
}
.logo-head .more-info .separate {
  padding: 0px 6px;
}
.logo-head .switch-language {
  position: relative;
}
.logo-head .switch-language .dropdown-toggle {
  position: absolute;
  text-align: center;
}
.logo-head .switch-language .dropdown-toggle svg {
  fill: rgba(255, 255, 255, 0.8);
}
.logo-head .switch-language .ant-select-selector {
  width: 38px;
  border-radius: 5px;
  opacity: 0;
}
@media (min-width: 0) and (max-width: 640px) {
  /* 头部样式调整 */
  .logo-head {
    padding: 0 5px;
  }
}
@media (min-width: 640px) {
  /* 头部样式调整 */
  .logo-head {
    padding: 0px 55px 0px 55px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Login/Components/Header/index.less"],"names":[],"mappings":"AAAA,WAAW;AACX;EACE,YAAA;EACA,kBAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AACF;AARA;EASI,eAAA;EACA,UAAA;EACA,0CAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AAEJ;AAjBA;EAkBQ,0CAAA;AAER;AApBA;EAsBM,gBAAA;AACN;AAvBA;EAsDI,kBAAA;AA5BJ;AA1BA;EAwDM,kBAAA;EACA,kBAAA;AA3BN;AA9BA;EA2DQ,8BAAA;AA1BR;AAjCA;EA+DM,WAAA;EACA,kBAAA;EACA,UAAA;AA3BN;AAgCA;EA9BE,WAAW;EAgCX;IACE,cAAA;EA9BF;AACF;AAiCA;EA/BE,WAAW;EAiCX;IACE,0BAAA;EA/BF;AACF","sourcesContent":["/* 头部样式调整 */\n.logo-head {\n  z-index: 999;\n  position: relative;\n  justify-content: space-between;\n  background: #333333;\n  min-height: 50px;\n  display: flex;\n  align-items: center;\n  .more-info {\n    margin: 0px 5px;\n    padding: 0;\n    color: rgba(255, 255, 255, 0.8) !important;\n    font-size: 14px;\n    list-style: none;\n    display: flex;\n    align-items: center;\n    li {\n      a {\n        color: rgba(255, 255, 255, 0.8) !important;\n      }\n    }\n    .separate {\n      padding: 0px 6px;\n    }\n  }\n  // .scroll-info {\n  //   position: relative;\n  //   color: #fabf00 !important;\n  //   font-size: 14px;\n  //   height: 30px;\n  //   width: 35%;\n  //   min-width: 100px;\n  //   overflow: hidden;\n  //   cursor: pointer;\n  //   // display: flex;\n  //   @keyframes moveAniHor {\n  //     0% {\n  //       left: 100%;\n  //     }\n  //     50% {\n  //       left: 0;\n  //     }\n  //     100% {\n  //       left: -100%;\n  //     }\n  //   }\n  //   .scroll-not {\n  //     position: absolute;\n  //     top: 0;\n  //     white-space: nowrap;\n  //     // animation: moveAniHor 8s linear infinite;\n  //   }\n  // }\n  .switch-language {\n    position: relative;\n    .dropdown-toggle {\n      position: absolute;\n      text-align: center;\n      svg {\n        fill: rgba(255, 255, 255, 0.8);\n      }\n    }\n    .ant-select-selector {\n      width: 38px;\n      border-radius: 5px;\n      opacity: 0;\n    }\n  }\n}\n\n@media (min-width: 0) and (max-width: 640px) {\n  /* 头部样式调整 */\n  .logo-head {\n    padding: 0 5px;\n  }\n}\n\n@media (min-width: 640px) {\n  /* 头部样式调整 */\n  .logo-head {\n    padding: 0px 55px 0px 55px;\n  }\n}\n\n@primary-color: #FABF00;@input-placeholder-color: #868686;@btn-primary-color: #454545;@checkbox-check-color: #454545;@checkbox-color: #E8AA0D;@radio-button-bg: #E8AA0D;@radio-button-checked-bg: #E8AA0D;@radio-button-color: #454545;@radio-button-active-color: #454545;@radio-solid-checked-color: #454545;@font-family: 'WenQuanYi Micro Hei', 'Micro Hei','Noto Sans CJK','Source Han Sans','Montserrat','Roboto','Lato','sans-serif';@btn-text-shadow: 0 0 0 rgba(0, 0, 0, 0);"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
